module.exports = require("@swa-ui/core/src/Show/Show.module.scss");